import { createContext } from 'react';

import { Optional } from '@vimeo/core/types/generic';

export interface IInteractionLoginContext {
  sessionId: string;
  joinLabel: string;
  isTermsLabelEnabled: boolean;
  isJoinLabelIconEnabled: boolean;
  isAccessBlocked: boolean;
  accessBlockedReason: Optional<string>;
  setIsTermsLabelEnabled: (isEnabled: boolean) => void;
  setJoinLabelIconEnabled: (isEnabled: boolean) => void;
  setAccessBlocked: (reason: Optional<string>) => void;
  setJoinLabels: (label: string) => void;
  resetLabels: () => void;
}

/**
 * Context object.
 */
export const InteractionLoginContext = createContext<IInteractionLoginContext>(
  {} as IInteractionLoginContext,
);
